import { ActionType } from '../../types';

export const TrendExportActions = {
    trendExportStarted: () =>
        ({
            type: 'TrendExport/Load/Started',
        } as const),

    trendExportSucceeded: (url: string) =>
        ({
            type: 'TrendExport/Load/Succeeded',
            payload: { url },
        } as const),

    trendExportFailed: () =>
        ({
            type: 'TrendExport/Load/Failed',
        } as const),

    trendExportUnmounted: () =>
        ({
            type: 'TrendExport/Load/Unmounted',
        } as const),
};

export type TrendExportActions = ActionType<typeof TrendExportActions>;
